import { useState, useEffect } from 'react';

const useMedia = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    const isMobile = width <= 767;
    const isTab = width >= 768 && width <= 1024;
    const isDesktop = !isMobile && !isTab;

    return { isDesktop, isMobile, isTab };
};

export { useMedia };
